import React, {
    Component,
    PropTypes
} from 'react';
import {
    Link
} from "react-router";
import {getUserId, resultTip, errToSuc, errorShow, successShow, language} from "UTIL/common"
import bumpService from 'SERVICES/purifier/bump/bumpService'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"
import ErrorSpan from "../../../component/errorSpan";
export default class PanalyzeCreate extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            data: [],
            msg: "",
            msgTypes: [],
            metaList: [],
            pframeworkList: [],
        }
    }

    componentDidMount() {
        bumpService.panalyzeAdd().then(data => {
            const list = data.data;
            this.setState({
                msgTypes: list.msgTypes,
                metaList: list.metaList,
                pframeworkList: list.pframeworkList,
                yesOrNo: list.yesOrNo
            })
        })
        $(".select2").select2();
    }

    submit(event) {
        errToSuc();
        event.preventDefault();
        const list = $("#metaNames").val();
        const metaIds = list == null ? "" : list.join(",");
        var selectedNames = [];
        $("#metaNames :selected").each(function () {
            selectedNames.push($(this).text());
        });
        const arr = {
            "pframeworkId": $("#pframeworkId").val(),
            "anCode": $.trim($("#anCode").val()),
            "anName": $.trim($("#anName").val()),
            "anValue": $.trim($("#anValue").val()),
            "hisMsgType": $('#hisMsgType option:selected').text(),
            "isSaveHis": $("#isSaveHis").val(),
            "metaIds": metaIds,
            "metaNames": selectedNames.join(","),
        };
        var errorMessage = '';
        for (let i in arr) {
            if(i!='metaNames'){
                if (arr[i] == '') {
                    errorShow(i);
                }
            }

        }
        if ($("[name='error']").length == 0) {
            var data = JSON.stringify(arr);
            bumpService.panalyzeInsertOrUpdate({data}).then(body => {
                resultTip(body, '/config/panalyze/panalyzeIndex')
            })
        }

    }

    render() {
        const metaList = this.state.metaList.map(function (str, index) {
            return <option value={str.id} key={index}>{str.name}</option>
        })
        const pframeworkList = this.state.pframeworkList.map(function (str, index) {
            return <option value={str.id} key={index}>{str.proName}</option>
        })
        const msgTypes = this.state.msgTypes;
        const msgTypesList = [];
        for (var prop in msgTypes) {
            if (msgTypes.hasOwnProperty(prop)) {
                const arr = {
                    "id": prop,
                    "name": msgTypes[prop]
                }
                msgTypesList.push(arr);
            }
        }
        const msgList = msgTypesList.map(function (str, index) {
            return <option value={str.id} key={index}>{str.name}</option>
        })
        const yesOrNo = this.state.yesOrNo;
        const yesOrNoList = [];
        for (var prop in yesOrNo) {
            if (yesOrNo.hasOwnProperty(prop)) {
                const arr = {
                    "id": prop,
                    "name": yesOrNo[prop]
                }
                yesOrNoList.push(arr);
            }
        }
        const List = yesOrNoList.map(function (str, index) {
            return <option value={str.id} key={index}>{str.name}</option>
        })
        return (
            <div >
                <section className="content-header">
                    <h1> {language()['CommandAnalysis']}
                        <small>{language()['CommandAnalysisAdd']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <BoxHeader name={language()['CommandAnalysisAdd']}/>
                        <div className="box-body">
                            <Tip ids=""/>
                            <form className="form-horizontal">
                                <div className="row form-group">
                                    <label
                                        className="multi-label control-label col-xs-2">{language()['pframework']}</label>
                                    <div className="col-xs-3">
                                        <select className="form-control" id='pframeworkId'>
                                            {pframeworkList}
                                        </select>
                                    </div>
                                </div>
                                <FormInput id="anCode" name="anCode"/>
                                <FormInput id="anName" name="anName"/>
                                <FormInput id="anValue" name="anValue"/>
                                <div className="row form-group">
                                    <label
                                        className="multi-label control-label col-xs-2">{language()['metaNames']}</label>
                                    <div className="col-xs-3">
                                        <select className="form-control select2" id='metaNames' multiple="multiple">
                                            {metaList}
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label
                                        className="multi-label control-label col-xs-2">{language()['isSaveHis']}</label>
                                    <div className="col-xs-3">
                                        <select className="form-control" id='isSaveHis'>
                                            {List}
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label
                                        className="multi-label control-label col-xs-2">{language()['hisMsgType']}</label>
                                    <div className="col-xs-3">
                                        <select className="form-control" id='hisMsgType'>
                                            {msgList}
                                        </select>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-1 text-center">
                                <Link to="/config/panalyze/panalyzeIndex" className="btn btn-default btn-md">
                                    {language()['return']}
                                </Link>
                            </div>
                            <div className="col-xs-1 text-center">
                                <button className="btn btn-success" id="btnSubmit"
                                        onClick={this.submit.bind(this)}>{language()['submit']}</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./modules/bump/config/panalyze/panalyzeCreate.js